import { api } from "./client";

export interface Hit {
  id: number;
  clientId: string;
  unitId: number;
  hotlistEntryId: number;
  vin: string | null;
  placa: string | null;
  latitude: number | null;
  longitude: number | null;
  fase: string;
  respuestaId: number | null;
  motivoDescarteId: number | null;
  comentarios: string | null;
  autoridadId: number | null;
  autoridadNotificadaAt: string | null;
  autoridadNotificacionCanal: string | null;
  operativoId: number | null;
  usuarioId: number | null;
  at: string;
  closedAt: string | null;
}

export interface Page<T> {
  items: T[];
  total: number;
  page: number;
  size: number;
}

export async function listHits(params: {
  fase?: string;
  page?: number;
  size?: number;
}): Promise<Page<Hit>> {
  const res = await api.get<Page<Hit>>("/hits", { params });
  return res.data;
}

export async function reportarHit(id: number, body: {
  respuestaId: number;
  comentarios?: string;
  autoridadId?: number;
  autoridadNotificadaAt?: string;
  autoridadNotificacionCanal?: string;
}): Promise<Hit> {
  const res = await api.post<Hit>(`/hits/${id}/reportar`, body);
  return res.data;
}

export async function descartarHit(id: number, body: {
  motivoDescarteId: number;
  comentarios: string;
  autoridadId?: number;
}): Promise<Hit> {
  const res = await api.post<Hit>(`/hits/${id}/descartar`, body);
  return res.data;
}
